import { useState, useEffect } from "react";
import { DateTime } from "luxon";
import { useLocalStorage } from "./useLocalStorage";
import { isString } from "../utils/strings";
export function useInput(key, initialValue) {
  var _a = useLocalStorage(key, initialValue, isString),
    value = _a[0],
    setValue = _a[1];
  var onChange = function (e) {
    setValue(e.target.value);
  };
  return {
    value: value,
    onChange: onChange
  };
}
export var useTime = function (refreshCycle) {
  if (refreshCycle === void 0) {
    refreshCycle = 1000;
  }
  var _a = useState(getTime()),
    now = _a[0],
    setNow = _a[1];
  useEffect(function () {
    var intervalId = setInterval(function () {
      return setNow(getTime());
    }, refreshCycle);
    return function () {
      return clearInterval(intervalId);
    };
  }, [refreshCycle, setNow]);
  return now;
};
var getTime = function () {
  return DateTime.local();
};